<ng-container *ngIf="showCard; else resumeWithoutCard">
  <common-mojo-expandable-card [expandable]="false">
    <mojo-candidate-resume-card-header
      *ngIf="!resumeTitleHidden"
      [showTitle]="true"
    >
    </mojo-candidate-resume-card-header>

    <mojo-pdf-viewer-adapter
      [pdfSrc]="resumeSrc"
      [pdfId]="resumeId"
    ></mojo-pdf-viewer-adapter>
  </common-mojo-expandable-card>
</ng-container>

<ng-template #resumeWithoutCard>
  <mojo-candidate-resume-card-header
    [showTitle]="false"
    *ngIf="!resumeTitleHidden"
  >
  </mojo-candidate-resume-card-header>

  <mojo-pdf-viewer-adapter
    [isFullScreenEnable]="false"
    [pdfSrc]="resumeSrc"
    [pdfId]="resumeId"
  ></mojo-pdf-viewer-adapter>
</ng-template>
